import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAdminIntegrationStatus } from '@/shared/hooks/useIntegrations';
import { FullPageShell } from '@/shared/components/FullPageShell';
import { AdminIntegrationsScreen } from './AdminIntegrationsScreen';
import { AdminProcessingScreen } from './AdminProcessingScreen';

type AdminView = 'integrations' | 'processing';

export function AdminFlow() {
  const { t } = useTranslation('onboarding');
  const { data: status, isLoading } = useAdminIntegrationStatus();
  const [viewOverride, setViewOverride] = useState<AdminView | null>(null);

  if (isLoading || !status) {
    return (
      <FullPageShell>
        <div className="flex-1 flex items-center justify-center">
          <p className="text-muted-foreground">{t('preparing')}</p>
        </div>
      </FullPageShell>
    );
  }

  const connectedProviders = status.connectedProviders;
  const derivedView: AdminView =
    connectedProviders.length === 0 ? 'integrations' : 'processing';
  const view = viewOverride ?? derivedView;

  return (
    <FullPageShell>
      {view === 'integrations' ? (
        <AdminIntegrationsScreen
          connectedProviders={connectedProviders}
          onContinue={() => setViewOverride('processing')}
        />
      ) : (
        <AdminProcessingScreen
          onManageIntegrations={() => setViewOverride('integrations')}
        />
      )}
    </FullPageShell>
  );
}
